import { css } from '@emotion/core';
import { Button } from '@material-ui/core';
import { PlayArrow } from '@material-ui/icons';
import React from 'react';

import { fullDateTime } from '../common/timestamp';
import { JobTitle } from '../containers/job-title';
import { AIInterviewRequest } from '../graphql/queries/ai-interview-requests';
import { useAudioPlayer } from '../hooks/use-audio-player';
import { useReduxState } from '../hooks/use-redux';
import { PersonAIInterview } from './person-ai-interview';

interface PersonAIInterviewsProps {
    personId: string;
    jobId?: string;
    requests: AIInterviewRequest[];
    onCreated: () => Promise<unknown>;
}

const styles = css`
    margin-top: 16px;

    .ai-interview {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }
`;

export const PersonAIInterviews: React.FC<PersonAIInterviewsProps> = ({ personId, jobId, requests, onCreated }) => {
    const { play } = useAudioPlayer();
    const personName = useReduxState((state) => state.personsDetails.list.get(personId)?.person.name.full);
    const links = requests.map((request) => {
        const completed = request.interviewTime != null;
        const date = fullDateTime(request.interviewTime ?? request.createdAt);
        const title = (
            <React.Fragment>
                <div>
                    {personName} <span style={{ whiteSpace: 'nowrap' }}>· {date}</span>
                </div>
                <div className="secondary small2">
                    <JobTitle id={request.jobId} />
                </div>
            </React.Fragment>
        );
        const handlePlay = () =>
            play({
                filename: 'recording.mp3',
                path: request.interviewRecordingFile,
                title
            });
        const playIcon = <PlayArrow />;
        const action = completed ? (
            <Button onClick={handlePlay} startIcon={playIcon}>
                Play AI interview recording
            </Button>
        ) : (
            <PersonAIInterview personId={personId} jobId={request.jobId} request={request} onCreated={onCreated} />
        );
        return (
            <div className="ai-interview" key={request.id}>
                {action}
                <span className="secondary small2">{date}</span>
            </div>
        );
    });
    const createButton =
        jobId && requests.length === 0 ? (
            <PersonAIInterview personId={personId} jobId={jobId} onCreated={onCreated} />
        ) : null;

    return (
        <div className="ai-interviews" css={styles}>
            {links}
            {createButton}
        </div>
    );
};
